var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{style:({paddingBottom: _vm.footerHeight + 'px'})},[_c('AppToolbar'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1),_c('CatFooter',{ref:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }